import { render, staticRenderFns } from "./FooterComponentWrktp.vue?vue&type=template&id=25c0be06&scoped=true"
import script from "./FooterComponentWrktp.vue?vue&type=script&lang=ts"
export * from "./FooterComponentWrktp.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentWrktp.vue?vue&type=style&index=0&id=25c0be06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0be06",
  null
  
)

export default component.exports